import React, { useState } from 'react';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';
import { useDispatch } from 'react-redux';

import DeptAddForm from '../../components/deptmng/DeptAddForm';
import { treeDeparts } from '../../modules/deptModule/departs';
import { viewDepart } from '../../modules/deptModule/depart';

import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

import * as departApi from '../../lib/api/department';
import _ from 'lodash';

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={
      <ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem', color: '#fff' }} />
    }
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    // theme.palette.mode === 'dark'
    //   ? 'rgba(255, 255, 255, .05)'
    //   : 'rgba(0, 0, 0, .03)',
    '#424242',
  color: '#fff',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

const DeptAddFormContainer = ({ depart }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [checkedRoles, setCheckedRoles] = useState([]);

  const onChangeChecked = (id) => {
    setCheckedRoles((checked) =>
      checked.includes(id)
        ? checkedRoles.filter((f) => f !== id)
        : [...checkedRoles, id],
    );
  };

  const initialValues = {
    dptNm: '',
    dptDesc: '',
    leaderUuid: '',
    emlAddr: '',
    ectVal1: '',
    ectVal2: '',
    ectVal3: '',
    statMerge: '',
  };

  const validationSchema = yup.object({
    dptNm: yup.string('').required('부서명을 입력하세요'),
    emlAddr: yup.string('').email('이메일 형식이 아닙니다').nullable(),
  });

  const getCheckedObject = () => {
    let obj = {};
    if (checkedRoles.length > 0) {
      _.forEach(checkedRoles, (role) => {
        obj[role] = 'Y';
      });
    }
    return obj;
  };

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);

      let dataToSubmit = {
        parentDptUuid: !depart ? null : depart.dptUuid,
        dptNm: values.dptNm,
        dptDesc: values.dptDesc,
        emlAddr: values.emlAddr,
        leaderUuid: values.leaderUuid,
        roleList: getCheckedObject(),
        ectVal1: values.ectVal1,
        ectVal2: values.ectVal2,
        ectVal3: values.ectVal3,
        statMerge: values.statMerge,
        useYn: 'Y',
      };

      //console.log(JSON.stringify(dataToSubmit), 'dataToSubmit');

      try {
        const response = await departApi.addDepart(dataToSubmit);
        if (response.data) {
          if (depart) {
            dispatch(viewDepart(depart.dptUuid));
          }
          dispatch(treeDeparts());
        }
      } catch (err) {
        let message =
          typeof err.response !== 'undefined'
            ? err.response.data.message
            : err.message;
        enqueueSnackbar(message, {
          variant: 'error',
        });
      }

      formik.resetForm();
      setCheckedRoles([]);
      setSubmitting(false);
    },
  });

  return (
    <Accordion sx={{ mt: 1 }}>
      <AccordionSummary
        aria-controls="depart-add-content"
        id="depart-add-header"
      >
        <Typography variant="subtitle1" component="div">
          {depart?.dptNm && `[${depart?.dptNm}]`} 하위부서 추가
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <DeptAddForm
          formik={formik}
          checkedRoles={checkedRoles}
          onChangeChecked={onChangeChecked}
        />
      </AccordionDetails>
    </Accordion>
  );
};

export default DeptAddFormContainer;
